<template>
  <el-row class="alltext" :style="{height:set_page.all_height}">
      <el-col :span="20" :offset="2">
        <el-table
          border
          :data="info.list"
          style="width: 100%"
          :height=set_page.table_height>
          <el-table-column
            prop="exam_name"
            label="试卷名称"
            >
          </el-table-column>
          <el-table-column
            prop="name"
            label="组卷人"
            >
          </el-table-column>
          <el-table-column
            prop="time"
            label="组卷日期">
          </el-table-column>
          <el-table-column
            prop="type"
            label="状态">
            <template slot-scope="scope">
              <span v-if="scope.row.type==0" >未审核</span>
              <span v-if="scope.row.type==1" style="color:red;">已驳回</span>
              <span v-if="scope.row.type==2" style="color:rgb(240, 249, 235);">已发布</span>
            </template>
          </el-table-column>
           <el-table-column
                fixed="right"
                label="操作"
                width="150">
                <template slot-scope="scope">
                  <el-button @click="operation(scope.row,'see')" type="text" size="small">查看</el-button>
                  <el-button type="text" size="small" @click="operation(scope.row,'publish')">发布/驳回</el-button>
                </template>
              </el-table-column>
        </el-table>
        <el-pagination
             class="fenye"
             @size-change="handleSizeChange"
             @current-change="handleCurrentChange"
             :current-page="info.currentPage"
             :page-size="info.pageSize"
             :page-sizes="[5, 10, 50, 100]"
             layout="total, sizes, prev, pager, next, jumper"
             :total="info.total">
           </el-pagination>
      </el-col>
      <el-dialog
        title="发布/驳回"
        :visible.sync="set_page.dialogVisible"
         width="50%"
        >
         <el-select v-model="set_page.value" filterable placeholder="请选择">
            <el-option
              v-for="item in set_page.type_list"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
          <el-input style="margin-top: 1.875rem;" v-model="set_page.input" placeholder="如果驳回请输入驳回原因"></el-input>
        <span slot="footer" class="dialog-footer">
          <el-button @click="set_page.dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="determine">确 定</el-button>
        </span>
      </el-dialog>
  </el-row>
</template>

<script>
  export default{
    data(){
      return{
        info:{
          list:[],
          currentPage:1,//当前页数
          pageSize:10,//一页显示多少条
          total:100,//总条数
          keyword:'',
        },
        set_page:{
          all_height:'',
          table_height:'',
          dialogVisible:false,
          value:'001',
          input:'',
          type_list:[{
            value: '001',
            label: '发布'
          },
          {
            value: '002',
            label: '驳回'
          },
          ]

        }
      }
    },
    mounted(){
      this.set_page.all_height=window.innerHeight   + 'px'
      this.set_page.table_height=window.innerHeight -80 + 'px'
      this.get_info()
    },
    methods:{
      get_info(){
        let _this=this
        for(let i=0;i<30;i++){
          let data={
            exam_name:'组卷'+i,
            name:'申请人'+i,
            time:'2022-08-01',
            type:1
          }
          _this.info.list[i]=data
        }
        _this.info.list[0].type=0
        _this.info.list[3].type=2
      },
      operation(item,type){
        if(type=='see'){

        }else{
          this.set_page.dialogVisible=true
        }
      },
      handleSizeChange(val){
        },
      handleCurrentChange(val) {
       },
      determine(){
        let _this=this
        if(_this.set_page.value=='002'){
          if(_this.set_page.input.length==0){
            _this.$message.error('请输入驳回原因')
          }else{
            let data={
              type:"002",
              reason:_this.set_page.input
            }
            _this.set_page.dialogVisible=false
            // console.log(data)
          }
        }else{
          let data={
            type:"001",
          }
          // console.log(data)
          _this.set_page.dialogVisible=false
        }
        _this.set_page.input=''
      },
    },

  }
</script>

<style scoped>
  .alltext{
    background-color: white;
    height: 100%;
    overflow: auto;
  }
  .fenye{
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 0.625rem;
  }
</style>



// WEBPACK FOOTER //
// src/view/company/evaluate/checher/list.vue